module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/volume-up-fee73a59a10b4cbbb66a5aaa9c5027fa.svg";